import api from '../config/axios';

export const getUsers = (params) => api.get('/users', { params });
export const getUserById = (id) => api.get(`/users/${id}`);
export const createUser = (data) => api.post('/users', data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data);
export const deactivateUser = (id) => api.delete(`/users/${id}`);
export const toggleUserStatus = (id) => api.patch(`/users/${id}/toggle-status`);
export const getUsersByRole = (role) => api.get(`/users/role/${role}`);
export const getTeamMembers = (managerId) => api.get(`/users/team/${managerId}`);
export const getBankersOverview = () => api.get('/users/bankers/overview');
export const getBankerTeam = (bankerId) => api.get(`/users/bankers/${bankerId}/team`);
export const addBankerTeamMember = (bankerId, data) => api.post(`/users/bankers/${bankerId}/team`, data);
export const removeBankerTeamMember = (memberId) => api.delete(`/users/bankers/team/${memberId}`);
export const getBankerDetail = (bankerId) => api.get(`/users/bankers/${bankerId}/detail`);
